<!--
 * @Author: Merlin
 * @Date: 2023-12-20 16:14:25
 * @LastEditors:  Merlin
 * @LastEditTime: 2025-05-01 13:41:53
 * @Description: 
-->
<template>
    <ButtonThe2RowsButton
        class="h-full"
        full-width
        v-click-and-rest="200"
        :dismark="isDiabled"
        :disabled="isDiabled"
        size="lg"
    >
        {{sFirstRow}}
        <template #secondRow v-if="sSecondRow || showMoney">
            <!-- ↓ 将通过 dom 定位为此处注入金额信息 -->
            <span class='second-row' 
                :class="{'show-crash-money': showMoney}"
            >
                {{sSecondRow}}
            </span>
            <p v-if="oParData.isAutoMode && showMoney"
                class="mt-1"
            >
                {{ autoOption.sRoundsRest }}
            </p>
        </template>
    </ButtonThe2RowsButton>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import useGlobalStore from '@/stores/global';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';


// 注入响应式的值
const oParData = inject('crash');
const globalStore = useGlobalStore();
const oAnimation = oParData.oAnimation;
const {t: $t} = useI18n();
const autoOption = useAutoOptionStore();

const hasStoppedBetting = computed(()=>{
    const aa = oParData.oAnimation?.state === 'fly';
    const bb = oParData.oAnimation?.hasStoppedBetting_;
    return aa || bb;
});

// 👇按钮第 1 行文字
const isDiabled = computed(()=>{
    if (oAnimation?.state === 'fly') return false; // ←不可禁用
    if (oAnimation?.name === 'PREPARING_NEXT_ROUND') {
        return false; // 准备阶段可下注、可取消，不可禁用它
    }
    const aCondition = [
        oParData.iJoinMark == 1,
        oAnimation?.hasStoppedBetting_ == false,
        // oAnimation?.state != 'crash',
    ];
    const bResult = aCondition.every(Boolean);
    return bResult;
});

// 👇按钮第 1 行文字
const sFirstRow = computed(()=>{
    if (oParData.isAutoMode){
        if (oParData.iJoinMark == 0){
            return $t(globalStore.autoModeBtnWords.start);
        }else{
            if (oParData.isPlanningToSotpAutoBet && oAnimation?.name == 'BETTING'){
                return $t('crash.FinishingBet');
            }
            return $t(globalStore.autoModeBtnWords.stop);
        }
    }
    // ▲自动模式
    // ▼手动
    if (oParData.iJoinMark == 1){
        // 已改为将 hasStoppedBetting 放在顶部 
        if (hasStoppedBetting.value){
            return $t('game.cashout').toUpperCase();
        } else if (oAnimation?.name == 'PREPARING_NEXT_ROUND'){
            return $t('crash.Cancel');
        } else if (oAnimation?.name == 'BETTING'){
            return $t('crash.Starting');
        }
        return $t('crash.Cancel');
    }else if (oParData.iJoinMark == 2){
        if (oAnimation?.name == 'BETTING'){
            return $t('crash.Starting');
        }
        return $t('crash.Cancel');
    }
    return $t('game.bet');
});

const showMoney = computed(()=>{
    const arr = [
        oParData.iJoinMark === 1,
        oAnimation?.state === 'fly',
        0 == oParData.oRound.stoppedAt, // 未提现时才显示金额
    ];
    const bResult = arr.every(Boolean);
    // console.log("按钮显示金额：", JSON.stringify(arr));
    return bResult;
});


// 👇按钮第 2 行文字
const sSecondRow = computed(()=>{
    if (showMoney.value) {
        return '';
    } else if (oParData.iJoinMark == 2){
        return '';
    } else if (hasStoppedBetting.value){
        if (oParData.isAutoMode) return '';
        return `(${$t('crash.nextRound')})`;
    }
    return '';
});

</script>


<style>

</style>
